import { TColors } from "@/types/colors.type";
import { TColorIntensity } from "@/types/colorIntensities.type";
import { TBorderWidth } from "@/types/borderWidth.type";
import { TRounded } from "@/types/rounded.type";

type TThemeConfigs = {
  themeColor: TColors;
  themeColorShade: TColorIntensity;
  rounded: TRounded;
  borderWidth: TBorderWidth;
  transition: string;
  fontSize: 12 | 13 | 14 | 15 | 16 | 17 | 18 | 19 | 20;
}

const themeConfig: TThemeConfigs = {
  themeColor: 'red',
  themeColorShade: '500',
  rounded: 'rounded-lg',
  borderWidth: 'border',
  transition: 'transition-all duration-300 ease-in-out',
  fontSize: 16,
}

export default themeConfig;